import React from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { translate } from '@/services/TranslationService';
import { Typography } from '@/components/novoville';

dayjs.extend(timezone);
dayjs.extend(utc);

const PaymentDetailsCard = ({ issueDate, type, rfCode, payerName }) => {
  return (
    <div className="border rounded-xl p-6 bg-white shadow-md max-w-xl w-full">
      <Typography variant="bold_20" className="mb-4">
        {translate('Details')}
      </Typography>

      <div className="flex justify-between text-gray-500 text-sm border-b py-2">
        <span>{translate('driver_license_issue_date')}</span>
        <span className="text-gray-800 font-semibold">
          {dayjs(issueDate.date).tz(issueDate.timezone).format('DD/MM/YYYY')}
        </span>
      </div>

      <div className="flex justify-between text-gray-500 text-sm border-b py-2">
        <span>{translate('Type')}</span>
        <span className="text-gray-800 font-semibold">{translate(type)}</span>
      </div>

      <div className="flex justify-between text-gray-500 text-sm border-b py-2">
        <span>{translate('RFCode')}</span>
        <span className="text-gray-800 font-semibold">{rfCode}</span>
      </div>

      <div className="flex justify-between text-gray-500 text-sm pt-2">
        <span>{translate('PayerName')}</span>
        <span className="text-gray-800 font-semibold">{payerName}</span>
      </div>
    </div>
  );
};

export default PaymentDetailsCard;
